<template>
  <view class="list-city">
    <view class="addr" wx:for="{{list}}" wx:key="index">
      <view
        wx:class="addr-city addr-base {{item.type === 2 ? 'addr-city-airport' : ''}}"
        catchtap="handleClick(item,$event)"
      >
        <view wx:class="addr-logo">
          <text>{{ item.type === -1 ? '省份' : item.type === 2 ? '机场' : '城市' }}</text>
        </view>
        <view class="addr-city-name">
          {{ item.name || item.city_name }}
        </view>
        <view wx:show="{{item.id}}" class="addr-code">
          {{ item.id }}
        </view>
      </view>
      <!-- 城市名 -->
      <view class="addr-airport">
        <view
          class="addr-base"
          wx:for="{{item.citys}}"
          wx:for-item="air"
          wx:for-index="airIndex"
          wx:key="airIndex"
          catchtap="handleClick({...air},$event)"
        >
          <view class="addr-logo addr-logo-airport">
            <text>城市</text>
          </view>
          <view class="addr-airport-name">
            {{ air[labelType] }}
          </view>
          <view wx:show="{{air.id}}" class="addr-code">
            {{ air.id }}
          </view>
        </view>
      </view>
      <!-- 车站名 -->
      <view class="addr-airport">
        <view
          class="addr-base"
          wx:for="{{item[type]}}"
          wx:for-item="air"
          wx:for-index="airIndex"
          wx:key="airIndex"
          catchtap="handleClick({...item, ...air},$event)"
          wx:show="{{airIndex < statusArr[index]}}"
        >
          <view class="addr-logo addr-logo-airport">
            <text>{{ label }}</text>
          </view>
          <view class="addr-airport-name">
            {{ air[labelType] }}
          </view>
          <view wx:show="{{air.id}}" class="addr-code">
            {{ air.id }}
          </view>
        </view>
      </view>
      <view
        class="show-more"
        wx:if="{{item[type].length > LIMIT_SHOW_STATION}}"
        bindtap="changeCollapse(index)"
        >{{ statusArr[index] === LIMIT_SHOW_STATION ? '展开更多车站' : '收起'
        }}<image
          class="show-more-arrow"
          src="{{statusArr[index] === LIMIT_SHOW_STATION ? 'https://dpubstatic.udache.com/static/dpubimg/1slb1OdJWmaOxS-6ScrSD.png' : 'https://dpubstatic.udache.com/static/dpubimg/89qPebOI7E6fZFTYRSXxV.png'}}"
      /></view>
    </view>
  </view>
</template>

<script>
  import mpx, { createComponent } from '@mpxjs/core'
  const MAX_SHOW_STATION = 999
  const LIMIT_SHOW_STATION = 6

  createComponent({
    props: {
      list: {
        type: Array,
        value: []
      },
      label: {
        type: String,
        value: '机场'
      },
      type: {
        type: String,
        value: 'airport_list'
      },
      labelType: {
        type: String,
        value: 'airport_name'
      }
    },
    data: {
      // 存储展开折叠状态
      statusArr: [],
      MAX_SHOW_STATION: 999,
      LIMIT_SHOW_STATION: 6
    },
    methods: {
      /**
       * @description: 点击事件
       * @param {*} city
       */
      handleClick(city, e) {
        if(city.type === -1) {
          return
        }
        if (e && typeof e.stopPropagation === 'function') {
          e.stopPropagation()
        }
        this.triggerEvent('handle', city)
      },
      // 展开折叠
      changeCollapse(index) {
        mpx.set(
          this.statusArr,
          index,
          this.statusArr[index] === this.LIMIT_SHOW_STATION
            ? this.MAX_SHOW_STATION
            : this.LIMIT_SHOW_STATION
        )
        this.triggerEvent('refresh')
      }
    },
    ready() {
      this.list.forEach((item) => {
        this.statusArr.push(this.LIMIT_SHOW_STATION)
      })
    }
  })
</script>

<style scoped lang="stylus" scoped>
  .list-city
    padding 0 16px
  .addr
    display flex
    flex-direction column
    align-items flex-start
  .addr-logo
    margin-right 8px
    font-size 10px
    border-radius 4px
    width 38px
    height 36rpx
    display flex
    align-items center
    justify-content center
    color #ffffff
    background #1473FF
  .addr-logo-airport
    color #1473FF
    background #ffffff
    border solid 0.5px #1473FF
  .addr-base
    box-sizing border-box
    height 47.5px
    border-bottom 1px solid rgba(0, 0, 0, 0.08)
    display flex
    align-items center
    justify-content flex-start
    width 100%
  .addr-airport
    box-sizing border-box
    padding-left 46px
    width 100%
  .addr-city, .addr-city-name
    font-family Ping Fang SC
    font-size 14px
    font-weight 600
    color #333333
  .addr-airport-name
    font-family Ping Fang SC
    font-size 14px
    font-weight 400
    color #333333
  .addr-code
    margin-left 8px
    font-family Ping Fang SC
    font-size 14px
    font-weight 400
    color #999999
  .show-more
    font-size 12px
    color #3D3D3D
    margin-top 16.5px
    padding-left 46px
    display flex
    align-items center
    line-height 12px
    padding-bottom 30px
    font-family PingFangSC-Regular
  .show-more-arrow
    width 16px
    height 16px
</style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>
